module.exports = __webpack_public_path__ + "img/octocamvision.63df51b1.png";